import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { BsCartPlusFill } from "react-icons/bs";
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia";
import { FaBook } from "react-icons/fa";
import { useGetSingleOfflineOrderDataQuery } from "src/services/OfflineOrderService";
import { CircularProgress } from "@mui/material";

type Props = {};

export const OffLineEditTabs: {
  label: string;
  icon: IconType;
  path: string;
}[] = [
  {
    label: "ORDER DETAILS",
    icon: BsCartPlusFill,
    path: "order-deatils",
  },
  {
    label: "PAYMENT DETAILS",
    icon: LiaMoneyBillWaveAltSolid,
    path: "payment-deatils",
  },
  {
    label: "BOOK DETAILS",
    icon: FaBook,
    path: "book-deatils",
  },
];

const ViewOfflineOrderLayout = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = useParams();
  const [offlineOrderData, setOfflineOrderData] = useState<any>({});
  const { data, isFetching, isLoading } =
    useGetSingleOfflineOrderDataQuery(orderId);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setOfflineOrderData(data?.data);
    }
  }, [isFetching, isLoading, data,offlineOrderData]);
  const currentPath = location.pathname.split("/")[4];

  return (
    <SideNavLayout>
      <div className="flex flex-col gap-2 pt-3 h-full">
        {/* OffLineEditTabs */}
        {OffLineEditTabs?.length && (
          <div className="flex gap-3 items-center  mx-4  border-b border-slate-400 bg-white ">
            {OffLineEditTabs?.map((tab: any, index: any) => {
              return (
                <div key={index}>
                  <button
                    type="button"
                    onClick={() => navigate(tab.path)}
                    className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-sm transition-all
        ${
          currentPath === tab.path?.split("/")[0]
            ? "text-primary-main   border-accent"
            : "text-gray-700 border-white"
        }
         `}
                  >
                    <div className=" text-lg  ">
                      <tab.icon />
                    </div>
                    {tab.label}
                  </button>
                </div>
              );
            })}
          </div>
        )}

        {/* Outlet */}
        <div className=" flex-1 flex flex-col overflow-auto ">
          {(isLoading || isFetching) && (
            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
              <CircularProgress />
            </div>
          )}
          <div className="flex-1">
            <Outlet context={[offlineOrderData]} />
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default ViewOfflineOrderLayout;
